var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95575 16C3.68141 16 2.40708 15.5044 1.41593 14.5841C-0.495576 12.6726 -0.495576 9.48673 1.41593 7.57522L7.9292 1.06195C8.63717 0.353982 9.48672 0 10.4779 0C11.3982 0 12.3186 0.353982 12.9558 1.06195C14.3717 2.47788 14.3717 4.67257 12.9558 6.0885L6.44248 12.6018C5.59292 13.4513 4.24779 13.4513 3.46903 12.6018C3.04425 12.177 2.83186 11.6106 2.83186 11.0442C2.83186 10.4779 3.04425 9.9115 3.46903 9.55752L9.48672 3.53982C9.76991 3.25664 10.1947 3.25664 10.4779 3.53982C10.7611 3.82301 10.7611 4.24779 10.4779 4.53097L4.46018 10.5487C4.31858 10.6903 4.24779 10.8319 4.24779 11.0442C4.24779 11.2566 4.31858 11.3982 4.46018 11.5398C4.74336 11.823 5.16814 11.823 5.45133 11.5398L11.9646 5.02655C12.8142 4.17699 12.8142 2.83186 11.9646 2.0531C11.1858 1.27434 9.76991 1.27434 8.99115 2.0531L2.47787 8.56637C1.06195 9.9823 1.06195 12.177 2.47787 13.5929C3.8938 15.0089 6.08849 15.0089 7.50442 13.5929L14.0177 7.07965C14.3009 6.79646 14.7257 6.79646 15.0088 7.07965C15.292 7.36283 15.292 7.78761 15.0088 8.0708L8.49557 14.5841C7.50442 15.5044 6.23009 16 4.95575 16Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1504,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/iconLink.20fbb90f28c2c51a6a34ab08ad91c7d5.svg";
export { ForwardRef as ReactComponent };